export const REPORT_REASON_ORDER = [
  'spam',
  'inappropriate',
  'copyright',
  'misleading',
  'harassment',
  'violence',
  'adult_content',
  'other',
] as const;

export const DEFAULT_REPORT_REASONS: Record<string, string> = {
  spam: 'Spam or repetitive content',
  inappropriate: 'Inappropriate or offensive content',
  copyright: 'Copyright infringement',
  misleading: 'Misleading or false information',
  harassment: 'Harassment or bullying',
  violence: 'Violence or harmful content',
  adult_content: 'Adult or explicit content',
  other: 'Other (please specify in details)',
};

export const getOrderedReasonEntries = (reasons: Record<string, string>): Array<[string, string]> => {
  const orderedEntries: Array<[string, string]> = [];

  REPORT_REASON_ORDER.forEach((key) => {
    if (reasons[key]) {
      orderedEntries.push([key, reasons[key]]);
    }
  });

  Object.entries(reasons).forEach(([key, label]) => {
    if (!REPORT_REASON_ORDER.includes(key as typeof REPORT_REASON_ORDER[number])) {
      orderedEntries.push([key, label]);
    }
  });

  return orderedEntries;
};
